( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function DeletePDFileCtrl ( $modalInstance, fileId, ppdFactory, Session, fileService ) {
		var self = this;

		self.location   = ppdFactory.getLocation();
		self.resourceId = ppdFactory.getResourceId();
		self.userId     = Session.getCredentials().userId;
		self.deleting   = false;
		self.type       = ppdFactory.getFileType();

		function close () {
			$modalInstance.close();
		}

		function cancel () {
			$modalInstance.dismiss();
		}

		function deleteFile () {
			self.deleting = true;

			var params = {
				'type'   : self.type,
				'userId' : self.userId
			};

			fileService.remove( fileId, params )
			.then( function () {
				close();
			} )
			.finally( function () {
				self.deleting = false;
			} );
		}

		self.close      = close;
		self.cancel     = cancel;
		self.deleteFile = deleteFile;
	}

	angular
		.module( 'app.components' )
		.controller( 'DeletePDFileCtrl', DeletePDFileCtrl );

	DeletePDFileCtrl.$inject = [ '$modalInstance', 'fileId', 'ppdFactory', 'Session', 'fileService' ];
} )( );
